import palette from '../palette';

export default {
  primary: { color: palette.text.primary }
};
